import React from 'react';

import Menu from '../../components/menu';
import Welcome from '../../components/welcome';

const Home = () => (
  <div className="page">
    <Welcome />
    <Menu modifier="landing" />
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/views/home/index.js